<template>
  <Layout>
    <div style="display: flex; height: calc(100vh - 220px);">
      <div style="width: 300px; flex: none; margin-right: 1.5rem; max-height: 80vh;" class="card overflow-auto">
        <treeCom @clickNode="clickNode" @clickNode1="clickNode1" ref="treeComRef" 
        @getWebsocket="getWebsocket"  @clearSelectNode="clearSelectNode"/>
      </div>
      <div style="width: calc(100% - 300px - 1.5rem); height: 100%;">
        <div class="card" style="height: 100%;">
          <div class="card-body" style="height: calc(100% - 32px); overflow-y: auto;">


            <cardCom :treedata="selectNode" v-show="showCard" @showTable="showTable" ref="cardRef" />
            <div v-show="!showCard">
              <div class="py-4 d-flex align-items-center" style="font-size: 16px; font-weight: 500;"><i
                  class=" bx bx-chevron-left cursor-pointer" style="color:#6D7080; font-size: 30px;" @click="showCardFn"
                  v-if="showBack" /> {{
                    currentInfo.name }}</div>
              <div v-show="allChecked.length">
                <div class="d-flex">
                  <div style="width: calc(100% - 200px)">
                    <div class="d-flex align-items-center">
                      <div class="d-flex" v-if="allChecked.length" style="overflow-x: auto">
                        <div class="d-flex align-items-center me-2" v-for="(a, index) in allChecked" :key="a.id">
                          <div class="p-2 pt-1 pb-1 me-1" :style="{
                            minWidth: '100px',
                            lineHeight: '18px',
                            background: 'rgba(102, 145, 231, 0.101961)',
                            borderRadius: '6px 4px 4px 6px',
                            borderLeft: [
                              '2px solid rgba(102, 145, 231)',
                              '2px solid rgba(134, 92, 226)',
                              '2px solid rgba(80, 195, 230)',
                              ' 2px solid rgba(236, 156, 98)',
                              '2px solid rgba(60, 146, 173)',
                            ][index],
                          }">
                            {{ a.eqName + a.name }}
                          </div>
                          <i @click="delCheckeds(a)" class="ri-delete-bin-line" style="
                          font-size: 18px;
                          line-height: 18px;
                          height: 18px;
                          color: #6691e7;
                          cursor: pointer;
                        "></i>
                        </div>
                      </div>
                      <!-- <div class="ms-2" style="min-width: 150px">
                    <button
                    type="button"
                    class="btn btn-primary"
                    @click="goRealTime()"
                  >
                    <i
                      class="mdi fs-16 mdi-chart-areaspline text-white me-1 align-middle"
                    ></i
                    >查看实时数据
                  </button>
                  </div> -->
                    </div>
                  </div>
                  <div style="width: 200px">
                    <div class="d-flex justify-content-end">
                      <!-- <button
                    type="button"
                    class="btn btn-primary"
                    @click="goHistory()"
                  >
                    <i
                      class="mdi fs-16 mdi-chart-areaspline text-white me-1 align-middle"
                    ></i
                    >查看历史数据
                  </button> -->
                      <button type="button" class="btn btn-primary" @click="goHistory()">
                        <i class="mdi fs-16 mdi-chart-areaspline text-white me-1 align-middle"></i>{{
                          this.$t("page.health-monitoring.viewing_historical_data") }}
                      </button>
                      <div class="d-flex justify-content-end align-items-center" @click="isCollapse = !isCollapse"
                        style="cursor: pointer">
                        <i :class="[
                          isCollapse
                            ? 'ri-arrow-down-s-fill'
                            : 'ri-arrow-up-s-fill',
                          'text-primary',
                        ]" style="font-size: 26px"></i>
                        <span>{{ isCollapse ? this.$t("page.health-monitoring.unfold") :
                          this.$t("page.health-monitoring.pack_up") }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="height: 450px" id="health_monitor" v-show="!isCollapse"></div>
              </div>
              <div :class="[!tableData.length && 'position-relative']">
                <Table v-show="tableData.length" :column="column" :tableData="paginate(tableData)" :allCheckedType="allCheckedType"
                  :measurementsList="measurementsList" :refresh_frequency="refresh_frequency"
                  v-model:singleData="singleData" @checkAllChanged="checkAllChanged" @singleChecked="singleChecked">
                </Table>
                <!-- paginate-part-->
                <Pagination v-if="tableData.length" class="me-3" v-model:page="page" v-model:perPage="perPage" :pages="pages"
                  :prePageOption="prePageOption" :tab_info_length="data_length"></Pagination>

                <Empty v-if="!tableData.length"></Empty>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <MessageAlert :alertInfo="alertInfo" v-if="formValidataAlert"></MessageAlert>
  </Layout>
</template>

<script>
import Layout from "@/layouts/main.vue";
import appConfig from "../../../app.config";
import Empty from "@/components/common/Empty";
import Pagination from "@/components/common/Pagination.vue";
import Table from "./table";
import { spectrumEcharts1 } from "../../utils/chart";
import _ from "loadsh";
import { getRawTimeseries, getLatestTimeseries, getInstancesDetailId } from "@/service/index";
import moment from "moment";
import MessageAlert from "@/components/common/MessageAlert";
import * as echarts from "echarts";
import { changeState } from "@/utils/filter.js";
import { valueFormatter1 } from "../../utils/common.js";
import qs from "qs";
import i18n from "@/i18n";
import treeCom from "./components/tree.vue";
import cardCom from "./components/card.vue";

export default {
  page: {
    title: i18n.global.t("menu.intelligent-operation-maintenance.health-monitor"),
    meta: [{ tag: 0, name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Empty,
    Pagination,
    Table,
    MessageAlert,
    treeCom,
    cardCom,
  },
  data() {
    return {
      title: this.$t("menu.intelligent-operation-maintenance.health-monitor"),
      items: [
        {
          text: this.$t("menu.intelligent-operation-maintenance.health-monitor"),
          href: "/health-monitor",
        },
        {
          text: this.$t("page.health-monitoring.health_monitoring_list"),
          active: true,
        },
      ],
      column: [
        { dataIndex: "name", title: this.$t("page.health-monitoring.measuring_point_name") },
        { dataIndex: "eqName", title: this.$t("page.work-order.device-name") },
        { dataIndex: "root_sn", title: this.$t("page.work-order.pump-head-sn") },
        { dataIndex: "group_sn", title: this.$t("page.work-order.unit-sn") },
        { dataIndex: "warn_status", title: this.$t("page.health-monitoring.EarlyWarningState") },
        { dataIndex: "ts", title: this.$t("page.health-monitoring.LastUpdateTime"), width: '200px', },
        { dataIndex: "curvalue", title: this.$t("page.health-monitoring.CurrentValue"), },
        { dataIndex: "unit", title: this.$t("page.work-order.device.unit") },
      ],
      tableData: [],
      originData: [],
      singleData: {},
      formType: null,
      isShowForm: false,
      isShowExpertExplain: false,
      /* 分页 */
      page: 1,
      perPage: 10,
      prePageOption: [10, 15, 20, 25],
      pages: [],
      data_length: 0,
      chartlist: [],
      allChecked: [],
      allCheckedType: false,
      isCollapse: true,
      windowTimeseriesData: [],
      timer: null,
      refresh_frequency: null,
      obj: null,
      itemId: null,
      datas: null,
      warnStatusList: ["healthy", "suboptimal", "error", "unknown"],
      alertInfo: {
        content: "",
        variant: "danger",
        icon: "ri-error-warning-line",
      },
      formValidataAlert: false,
      color: [
        "rgba(102, 145, 231)",
        "rgba(134, 92, 226)",
        "rgba(80, 195, 230)",
        "rgba(236, 156, 98)",
        "rgba(60, 146, 173)",
        "rgba(30, 33, 37)",
      ],
      //dataZoom的配置
      dataZoom: [
        {
          start: 0,
          end: 100,
        },
      ],
      measurementsList: [],
      shadowIds:[],
      mockSourceIds: [],
      historyList: [],
      selectNode: [],
      showCard: true,
      currentInfo: {},
      showBack: true,
    };
  },
  watch: {
    tableData: {
      handler(newVal) {
        // this.$store.commit(
        //   "healthMonitor/set_threshold_old_tabledata",
        //   JSON.stringify(newVal)
        // );
        const totalPage = Math.ceil(newVal.length / this.perPage); // 总页数
        this.page = this.page > totalPage ? totalPage : this.page;
        this.page = this.page < 1 ? 1 : this.page;
        this.setPages();
      },
      deep: true,
      immediate: true,
    },
    perPage(val) {
      if (val) {
        this.page = 1;
        this.setPages();
        this.paginate(this.tableData);
      }
    },
    // allChecked: {
    //   handler(newVal) {
    //     if (newVal.length) {
    //       this.goRealTime();
    //     } else {
    //       this.chartlist = [];
    //       this.dataZoom = [
    //         {
    //           start: 0,
    //           end: 100,
    //         },
    //       ];
    //     }
    //   },
    //   deep: true,
    // },
  },

  methods: {
    buildMockSourceFromPayload(payload) {
      if (!payload || !payload.id) return null;
      const measurements =
        payload.attributes && Array.isArray(payload.attributes.measurements)
          ? payload.attributes.measurements
              .filter((item) => item && item.key)
              .map((item) => ({
                key: item.key,
                name: item.name,
                full_name: item.full_name,
                unit: item.unit,
                operationThresholdLow: item.operationThresholdLow,
                operationThresholdHigh: item.operationThresholdHigh,
                standardThresholdLow: item.standardThresholdLow,
                standardThresholdHigh: item.standardThresholdHigh,
              }))
          : [];
      return {
        shadowId: payload.id,
        equipName: payload.name || "",
        measurements,
      };
    },
    registerMockSourceFromPayload(payload) {
      const source = this.buildMockSourceFromPayload(payload);
      if (!source) return;
      this.$websocket.dispatch("WEBSOCKET_REGISTER_MOCK_SOURCE", source);
      if (!this.mockSourceIds.includes(source.shadowId)) {
        this.mockSourceIds.push(source.shadowId);
      }
    },
    showCardFn() {
      this.showCard = true;
      this.allChecked = []
      this.allCheckedType = false
    },
    async showTable(item) {
      this.showCard = false;
      this.currentInfo = item;
      // 点击card里面的项 需要设置tree当前选择项 保持一致
      this.$refs.treeComRef.setNode(item.id)
      // 查询详情
      let params = {
        id: item.id,
      };
      const reps = await getInstancesDetailId(params)
      
      this.measurementsList = [];
      this.shadowIds = []
      this.measurementsList.push(reps.payload);
      this.registerMockSourceFromPayload(reps.payload);
      this.shadowIds.push(reps.payload.id)
      this.tableData = reps.payload.attributes.measurements.filter(item=> item.is_show).map(item => {
        return {
          ...item,
          eqName: reps.payload.name,
          root_sn: reps.payload.root_sn,
          group_sn: reps.payload.group_sn,
          warn_status: '',
          ts: '',
          curvalue: '',
          eqId: reps.payload.id
        }
      });
      // 获取子集的测点
      if (item.children) {
        item.children.forEach(item => {
          this.shadowIds.push(item.id)
          let params = {
            id: item.id,
          };
          getInstancesDetailId(params).then(reps => {
            this.measurementsList.push(reps.payload);
            this.registerMockSourceFromPayload(reps.payload);
            let arr = reps.payload.attributes.measurements.filter(item=> item.is_show).map(item1 => {
              return {
                ...item1,
                eqName: reps.payload.name,
                root_sn: reps.payload.root_sn,
                group_sn: reps.payload.group_sn,
                warn_status: '',
                ts: '',
                curvalue: '',
                eqId: reps.payload.id
              }
            })
            this.tableData = [...this.tableData, ...arr]
          })
        })
      }
      // this.getValueHealthData({
      //   obj:  reps.payload,
      //   itemId: null,
      //   clickType: "1",
      // })
    },
    moment,
    getWebsocket(socdata) {
      if (this.tableData && this.tableData.length > 0) {
        socdata.map((soc) => {
          this.tableData.map((t) => {
            if (this.shadowIds.includes(soc.shadowId)) {
              soc.report.map((so) => {
                if (so.id == t.key) {
                  t.value = valueFormatter1(so.v);
                  t.curvalue = valueFormatter1(so.v);
                  t.ts = moment().format("YYYY-MM-DD HH:mm:ss");
                  t.warn_status = changeState(
                    so.v,
                    {
                      operationThresholdLow: Number(
                        t.operationThresholdLow
                      ),
                      operationThresholdHigh: Number(
                        t.operationThresholdHigh
                      ),
                      standardThresholdHigh: Number(
                        t.standardThresholdHigh
                      ),
                      standardThresholdLow: Number(
                        t.standardThresholdLow
                      ),
                    },
                    t.ts
                  );
                }
              });
            }
          });
        });

      }

      if (
        socdata &&
        socdata.length &&
        this.allChecked.length &&
        this.chartlist.length &&
        this.chartlist[0].data.length
      ) {
        socdata.map((soc) => {
          this.chartlist.map((s) => {
            if (s.instanceId == soc.shadowId) {
              let _ts = moment().valueOf()
              soc.report.map((so) => {
                if (so.id == s.key) {
                  s.data.shift();
                  s.data.push({
                    name: _ts,
                    value: [_ts, valueFormatter1(so.v)],
                  });
                }
              });
            }
          });
        });


        this.$nextTick(() => {
          spectrumEcharts1({
            chartDom: document.getElementById("health_monitor"),
            dataList: this.chartlist,
            dataZoom: this.dataZoom,
          }, true);
        });
      }
    },
    delCheckeds(a) {
      this.singleChecked(a.id, false);
      this.allChecked = this.allChecked.filter((item) => {
        return item.id != a.id;
      });
    },
    goHistory() {
      var obj = [];
      this.allChecked.map((item) => {
        obj = this.measurementsList.filter((o) => {
          return o.id == item.eqId && o.name == item.eqName;
        });
      });
      localStorage.setItem("equipmentData", JSON.stringify(...obj));
      localStorage.setItem("historyData", JSON.stringify(this.allChecked));
      sessionStorage.setItem("deviceTreeActive", obj[0].id);
      this.$router.push({
        path: "/iot/atlas-analysis",
      });
    },
    goRealTime() {
      this.chartlist = [];
      this.allChecked.map((item, index) => {
        this.chartlist.push({
          instanceId: item.eqId,
          name: item.eqName + item.name,
          key: item.key,
          unit: item.unit,
          type: "line",
          symbolSize: 0,
          yAxisIndex: index,
          data: [],
          lineStyle: {
            normal: {
              width: 1,
            },
            emphasis: { width: 2 },
          },
        });
      });
      let column = _.map(this.allChecked, "key");
      let paramsdata = {
        start: "1h",
        end: "0m",
        limit: 7200,
        column,
      };
      let params = qs.stringify(paramsdata, { arrayFormat: "repeat" });
      var idList = [];
      this.allChecked.map((item) => {
        idList.push(item.eqId);
      });
      idList = idList.filter(
        (item, index, idList) => idList.indexOf(item) === index
      );

      idList.map((item) => {
        getRawTimeseries(item, params).then((res) => {
          res.payload.slice(-20).map((item) => {
            this.chartlist.map((s) => {
              for (let i in item) {
                if (s.key == i) {
                  s.data.push({
                    name: moment(item["ts"]).valueOf(),
                    value: [moment(item["ts"]).valueOf(), valueFormatter1(item[i])],
                  });
                }
              }
            });
          });
          this.$nextTick(() => {
            spectrumEcharts1({
              chartDom: document.getElementById("health_monitor"),
              dataList: this.chartlist,
              dataZoom: this.dataZoom,
            });
            const myChart = echarts.getInstanceByDom(
              document.getElementById("health_monitor")
            );
            myChart.on("dataZoom", (event) => {
              this.dataZoom[0].start = event.start;
              this.dataZoom[0].end = event.end;
            });
          });
        });
      });
    },
    getObjArr(data) {
      let result = [];
      let queue = data;
      while (queue.length > 0) {
        [...queue].forEach((child) => {
          /* 测点列表,筛选出需要展示的测点数据 */
          let info = _.cloneDeep(child)
          let list = []
          if (info.attributes && info.attributes.measurements.length) {
            list = info.attributes.measurements.filter(item => item.is_show === undefined || item.is_show)
          }
          child.attributes.measurements = list

          queue.shift();
          _.get(child, ["attributes", "measurements"]).map((item) => {
            item["eqName"] = child.name;
            item["eqId"] = child.id;
            item["root_sn"] = child.root_sn || "";
            item["group_sn"] = child.group_sn || "";
          });
          result.push(..._.get(child, ["attributes", "measurements"]));

          child.children && queue.push(...child.children);
        });
      }
      return result;
    },
    getTableArr(data) {
      let result = [];
      let queue = data;
      while (queue.length > 0) {
        [...queue].forEach((child) => {
          queue.shift();
          result.push(child);
          child.children && queue.push(...child.children);
        });
      }
      return result;
    },
    getValueHealthData({ obj, itemId, clickType }) {

      if (clickType == "1") {
        this.allChecked = [];
        this.allCheckedType = false;
        this.tableData = []
      }
      if (!obj) return;
      this.obj = obj;

      this.itemId = itemId;
      this.measurementsList = this.getObjArr([obj], "measurements");
      if (itemId) {
        this.measurementsList = this.measurementsList.filter((item) => {
          return item.id == itemId;
        });
      }
      this.historyList = this.getTableArr([obj]);
      var data = [];
      var idList = [];
      let _t = ""
      this.measurementsList.map((item) => {
        if (item.eqId !== _t && idList.indexOf(item.eqId) === -1) {
          idList.push(item.eqId);
          _t = item.eqId
        }
      });
      if (idList.length === 0) {
        this.tableData = [];
        this.originData = [];
        this.allChecked = [];
        this.allCheckedType = false;
        return;
      }
      // 去重
      // idList = idList.filter(
      //   (item, index, idList) => idList.indexOf(item) === index
      // );
      idList.map((iitem, index) => {
        getLatestTimeseries(iitem)
          .then((res) => {
            var list = [];
            data.push({ data: res.payload, id: iitem });
            this.measurementsList.map((item) => {
              if (data.length) {
                data.map((datas) => {
                  datas.data.map((s) => {
                    for (let i in s) {
                      if (item["key"] == i && item["eqId"] == datas.id) {
                        item["value"] = s[i];
                        item["curvalue"] = s[i];
                        item.warn_status = changeState(
                          item["value"],
                          {
                            operationThresholdLow: Number(
                              item.operationThresholdLow
                            ),
                            operationThresholdHigh: Number(
                              item.operationThresholdHigh
                            ),
                            standardThresholdHigh: Number(
                              item.standardThresholdHigh
                            ),
                            standardThresholdLow: Number(
                              item.standardThresholdLow
                            ),
                          },
                          s["ts"]
                        );
                        item.ts = moment(s["ts"]).format("YYYY-MM-DD HH:mm:ss");
                      }
                    }
                  });
                });
              } else {
                item.warn_status = "unknown";
              }
              list.push(item);
            });

            if (index == idList.length - 1) {
              list.map((s) => {
                this.getTableArr([obj]).map((item) => {
                  if (item.name === s.eqName) {
                    _.get(item, ["attributes", "attributes"]).map((a) => {
                      if (
                        a.group == this.$t("page.work-order.device.equipment_delivery_information") ||
                        a.group == this.$t("page.work-order.device.device_management_information")
                      ) {
                        s[a.name] = a.value;
                      }
                    });
                    s["deviceName"] = item.name;
                    s["checked"] = false;
                  }
                });
              });
              if (itemId)
                list = list.filter((item) => {
                  return item.id == itemId;
                });
              let searchValue = localStorage.getItem("searchValue");
              if (searchValue)
                list = list.filter((item) => {

                  return (
                    item.name
                      .replace(/\s*/g, "")
                      .toUpperCase()
                      .includes(
                        searchValue.replace(/\s*/g, "").toUpperCase()
                      ) ||
                    item["deviceName"]
                      .replace(/\s*/g, "")
                      .toUpperCase()
                      .includes(
                        searchValue.replace(/\s*/g, "").toUpperCase()
                      ) ||
                    item[this.$t("page.health-monitoring.UnitName")]
                      .replace(/\s*/g, "")
                      .toUpperCase()
                      .includes(
                        searchValue.replace(/\s*/g, "").toUpperCase()
                      ) ||
                    item[this.$t("page.health-monitoring.DeviceArea")]
                      .replace(/\s*/g, "")
                      .toUpperCase()
                      .includes(
                        searchValue.replace(/\s*/g, "").toUpperCase()
                      ) ||
                    item["unit"]
                      .replace(/\s*/g, "")
                      .toUpperCase()
                      .includes(searchValue.replace(/\s*/g, "").toUpperCase())
                  );
                });
              this.tableData = _.cloneDeep(list);
              this.originData = _.cloneDeep(list);
              this.allChecked.map((item) => {
                this.tableData.map((s) => {
                  if (item.id == s.id) {
                    s.checked = true;
                  }
                });
              });


            }
          })
          .catch(() => {
            _.get(obj, ["attributes", "measurements"]).map((item) => {
              item.warn_status = "unknown";
            });
          });
      });
    },
    /* 筛选分页数据 */
    paginate(data) {
      let page = this.page;
      let perPage = this.perPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      return data.slice(from, to);
    },
    /* 设置分页选项 */
    setPages() {
      this.pages = [];
      this.data_length = this.tableData.length;
      let numberOfPages = Math.ceil(this.tableData.length / this.perPage);

      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    /* 表格全选 */
    checkAllChanged(allChecked) {
      this.isCollapse = false;

      if (allChecked) {
        this.allChecked = this.tableData;
        this.allCheckedType = true;
      } else {
        this.allChecked = [];
        this.allCheckedType = false;
        this.isCollapse = true;
      }
      this.tableData.forEach((item) => {
        item.checked = allChecked;
      });
      this.goRealTime()
    },
    /* 表格项单选 */
    singleChecked(id, checked) {
      this.isCollapse = false;
      let i = this.tableData.findIndex((item) => {
        return item.id == id;
      });
      if (i != -1) {
        this.tableData[i].checked = checked;
      }
      this.allChecked = this.tableData.filter((item) => {
        if (item.checked == false) {
          this.allCheckedType = false;
        }
        return item.checked == true;
      });
      if (this.allChecked.length == this.tableData.length) {
        this.allCheckedType = true;
      }
      if (this.allChecked.length == 0) {
        this.isCollapse = true;
      }
      this.goRealTime()
    },
    clearTimer() {
      clearInterval(this.timer);
      this.timer = null;
    },
    setTableData(arr) {
      this.tableData = arr;
    },
    refreshFrequency(time) {
      this.refresh_frequency = time;
      clearInterval(this.timer);
      if (this.obj) {
        this.getValueHealthData(
          { obj: this.obj, itemId: this.itemId },
          "noinit"
        );
      }
      // if (time) {
      //   this.timer = setInterval(() => {
      //     if (this.obj) {
      //       this.getValueHealthData(
      //         { obj: this.obj, itemId: this.itemId },
      //         "noinit"
      //       );
      //     }
      //   }, time * 1000);
      // }
    },
    handleAlert(
      variant = "danger",
      message = "",
      icon = "ri-error-warning-line",
      duration = "3000"
    ) {
      this.formValidataAlert = true;
      this.alertInfo.variant = variant;
      this.alertInfo.icon = icon;
      if (message) {
        this.alertInfo.content = message;
      }
      setTimeout(() => {
        this.formValidataAlert = false;
      }, duration);
    },
    clickNode(node) {
      this.selectNode = []
      this.tableData = []
      this.currentInfo = node.data
      this.showCard = true
      this.allChecked = [];
      this.allCheckedType = false;
      // this.showCard = true
      // this.selectNode.push(data);
      this.$refs.cardRef.level = node.level
      if (node.level == 1) {
        this.selectNode.push(node.data)
      } else if (node.level >= 1) {
        let m = {
          name: node.data.name,
          id: node.data.id,
          children: []
        }
        this.selectNode.push(m)
        this.selectNode[0].children.push(node.data)
      }
      // console.log('clickNode',this.selectNode)
    },
    clickNode1(node) {
      this.selectNode = []
      this.tableData = []
      this.currentInfo = node.data
      this.showBack = true;
      this.$refs.cardRef.level = node.level
      if (node.level == 1) {
        this.selectNode.push(node.data)
      } else if (node.level >= 1) {
        let m = {
          name: node.data.name,
          id: node.data.id,
          children: []
        }
        this.selectNode.push(m)
        this.selectNode[0].children.push(node.data)
      }
      // console.log('clickNod1',this.selectNode)
    },
    //左侧搜索无数据，右侧应清空数据内容。
    clearSelectNode(){
      this.showCard = true
      this.selectNode = []
      this.tableData = []
    },
  },
  mounted() {
    // sessionStorage.removeItem("deviceTreeActive") //重新刷新页面无上一个选择设备
    // //处理初始化时，若未点击左侧树结构,但树结构已有active,则内容对应改变
    // let deviceTreeActive = sessionStorage.getItem("deviceTreeActive") || "";
    // var obj = JSON.parse(localStorage.getItem("equipmentData"));
    // if (deviceTreeActive && deviceTreeActive.includes("&&")) {
    //   //包含&&,树avtive是测点，反之是设备
    //   let itemId = deviceTreeActive.split("&&")[1];
    //   this.getValueHealthData({ obj, itemId });
    // } else if (deviceTreeActive && !deviceTreeActive.includes("&&")) {
    //   this.getValueHealthData({ obj: obj, itemId: null });
    // }
  },
  beforeUnmount() {
    if (this.mockSourceIds.length) {
      this.$websocket.dispatch("WEBSOCKET_UNREGISTER_MOCK_SOURCE", this.mockSourceIds);
      this.mockSourceIds = [];
    }
    // this.chartlist = [];
    // this.clearTimer();
    // localStorage.removeItem("searchValue");
  },
};
</script>
<style lang="scss"></style>
